import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get, isArray } from 'lodash';

import Link from "../../../components/Link";
import Text from "../../../components/Text";
import SubMenu from "./SubMenu";
import MegaMenu from "./MegaMenu";
import AsyncGet from "../../../components/AsyncGet";
import FeaturedArticle from "./FeaturedArticle";

import style from './style.module.css';

export default function MobileMenu({ status }) {

    const userData = useSelector((state) => state.storage.data);
    const [sideMenu, sideMenuStatus] = useState(null);
    const setSideMenu = (activeId) => {
        sideMenuStatus((prevId) => (prevId === activeId ? null : activeId));
    }

    useEffect(() => {
        if (status === false) {
            sideMenuStatus(null)
        }
    }, [status])

    return (
        <div className={`${style.mobileMenu} ${status ? style.active : ''}`}>
            <div className={`${style.mobileMenuContainer} ${style.c}`}>
                <AsyncGet
                    url="/header"
                    permissionText="List"
                    loadOnMount={true}
                    render={({ data }) => {
                        if (isArray(data.links) && data.links.length > 0) {
                            return (
                                <div className={style.mobileMainMenuRow}>
                                    {
                                        data.links.map((item, index) => {
                                            if ((item.menu_type === "mega_menu" || item.menu_type === "sub_menu") && (item.show_in_public === "1" || get(userData, "id") !== undefined)) {
                                                let id = "mobileMegaMenu" + index;
                                                return (
                                                    <div key={`mobileMainMenuItem_${index}_${item.label}`} className={`${style.mobileMainMenuItem}`}>
                                                        <div onClick={() => { setSideMenu(id) }} className={`${style.mobileMainMenuItemHeader} ${sideMenu === id ? style.active : ''} ${style.cursorPointer}`}>
                                                            <Link to={item.url} className={`${style.mobileMainMenuItemLink}`} key={`mobileMainMenuItemLink_${index}`}>{item.label}</Link>
                                                            <span className={`${style.dropDown} ${style.right}`}></span>
                                                        </div>
                                                        <div className={style.mobileMegaMenu}>
                                                            <div className={`${style.mobileMegaMenuRow}`}>
                                                                <div className={`${style.mobileMegaMenuLeftColumn} ${get(item, "featured_article", []).length > 0 ? style.featuredYes : ''}`}>
                                                                    <div className={`${style.mobileMegaMenuLeftColumnRow}`}>
                                                                        <div onClick={() => { setSideMenu(null) }} className={`${style.mobileMegaMenuHeader} ${style.mobileMegaRightMenuHeader}`}>
                                                                            <span className={`${style.dropDown} ${style.left}`}></span>
                                                                            <Text className="megaMenuTitle" text={item.label} />
                                                                        </div>
                                                                        {
                                                                            item.menu_type === "mega_menu" && item.mega_menu.length > 0 && (
                                                                                <MegaMenu megaMenu={item.mega_menu} type="mobile" />
                                                                            )
                                                                        }
                                                                        {
                                                                            item.menu_type === "sub_menu" && item.sub_menu.length > 0 && (
                                                                                <SubMenu subMenu={item.sub_menu} type="mobile" />
                                                                            )
                                                                        }
                                                                    </div>
                                                                    {
                                                                        ((item.menu_type === "mega_menu" && get(item, "featured_article", []).length > 0) &&
                                                                            <FeaturedArticle
                                                                                featuredList={item.featured_article}
                                                                                type="mobile"
                                                                                buttonLabel={item.button_label}
                                                                                buttonLink={item.button_url}
                                                                            />
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            } 
                                            else {
                                                if (item.show_in_public === "1" || get(userData, "id") !== undefined) {
                                                    return (
                                                        <div className={`${style.mobileMainMenuItem}`} key={`mainMenuItem_${index}`}>
                                                            <div className={style.mobileMainMenuItemHeader}>
                                                                <Link className={style.mobileMainMenuItemLink} to={item.url}>{item.label}</Link>
                                                            </div>
                                                        </div>
                                                    )
                                                } 
                                                else {
                                                    return null;
                                                }
                                            }
                                        })
                                    }
                                </div>
                            )
                        }
                    }}
                />
            </div>
        </div>
    )
}